import m from "../../geodata/es2015/ukraineLow";
window.am4geodata_ukraineLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukraineLow.js
// module id = null
// module chunks = 